// extracted by mini-css-extract-plugin
export default {"tooltip":"PP-z","arrow":"QP-z"};